<div class="dashboard-wrapper">
    <div class="position-relative">
        <div class="dark-theme fixed-top border-bottom">
            <div class="container-fluid">
                <div class="row">
                    <div class="d-none d-lg-block col-lg">
                        <div class="subtitle text-uppercase py-3">Reset your password</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="onboarding" *ngIf="currentIndex == 0">
        <h2 class="py-3 pl-4 col-12">Please wait...</h2>
        <div class="reflection-journal-theme border-bottom">
            <div>
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
            </div>
        </div>
    </div>

    <div class="onboarding" *ngIf="currentIndex == 1">
        <h2 class="py-3 pl-4 col-12">Reset your password</h2>
        <div class="reflection-journal-theme border-bottom">
            <div>
                <form [formGroup]="newPasswordForm" (ngSubmit)="onSetNewPassword()">
                    <div class="container-fluid py-4 border-bottom">
                        <div class="row">
                            <div class="form-group w-100">
                                <div class="col-12 col-lg-10 subtitle">
                                    <label for="newPassword">New Password</label>
                                </div>
                                <div class="col-12 col-lg-9">
                                    <input type="password" formControlName="newPassword" class="form-control text-xlarge" placeholder="Create a new secure password" required>
                                    <ng-container *ngFor="let validation of validationMessages.newPassword">
                                        <div class="error-message text-red" *ngIf="newPasswordForm.get('newPassword').hasError(validation.type) && (newPasswordForm.get('newPassword').dirty || newPasswordForm.get('newPassword').touched)">{{validation.message}}</div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid py-4 border-bottom">
                        <div class="row">
                            <div class="form-group w-100">
                                <div class="col-12 col-lg-10 subtitle">
                                    <label for="newPasswordRepeat">Confirm New Password</label>
                                </div>
                                <div class="row pt-2">
                                    <div class="col-12 col-lg-9">
                                        <input type="password" formControlName="newPasswordRepeat" class="form-control text-xlarge" placeholder="Re-type your password" required>
                                        <ng-container *ngFor="let validation of validationMessages.newPasswordRepeat">
                                            <div class="error-message text-red" *ngIf="newPasswordForm.get('newPasswordRepeat').hasError(validation.type) && (newPasswordForm.get('newPasswordRepeat').dirty || newPasswordForm.get('newPasswordRepeat').touched)">{{validation.message}}</div>
                                        </ng-container>
                                        <ng-container *ngIf="newPasswordForm.errors?.notmatched && (newPasswordForm.touched || newPasswordForm.dirty)">
                                            <div class="error-message text-red">Password mismatch</div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-6 col-lg-6 py-3 pl-4">
                <button type="button" class="btn btn-primary px-4" href="#" [disabled]="!newPasswordForm.valid" (click)="onSetNewPassword()">continue</button>
            </div>
        </div>
    </div>
</div>